module.exports = __webpack_public_path__ + "img/referandearn.a9968883.png";